import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './GameCont.module.scss';
import { InviteMessageDTO } from '@envclient/envcore/src/types/core';
import { ClosableCompProps } from './types';
import AppHeader from './AppHeader';
import Lobby from './Lobby';
import GameList from './GameList';
import Chat from './Chat';
import InviteDialog from './InviteDialog';
import store, { history, RootState, useAppSelector } from '../reducers/store';
import { setFirstConnect } from '../reducers/firstConnectReducer';
import { getUserInfo } from '../service/userService';
import WsConnection from '../service/WsConnection';
import { createGameActions } from '../reducers/createGameReducer';
import { AppStatus } from '../reducers/appStatusReducer';
import { useLocation } from 'react-router-dom';

const GameCont: FC<GameContProps> = ({ GameView, CreateGame, Guide }) => {
  const appStatus = useSelector((state: RootState) => state.appStatus);

  const invites = useSelector((state: RootState) => state.invites) as InviteMessageDTO[];
  const [inviteOpen, setInviteOpen] = useState<boolean>(false);
  const showCreate = useAppSelector<boolean>((state) => state.createGame);

  const dispatch = useDispatch();

  useEffect(() => {
    //load user then connect
    store.dispatch(setFirstConnect(false));
    getUserInfo().then(() => WsConnection.connect());
  }, []);

  // invites
  useEffect(() => {
    if (invites?.length === 0) return;
    setInviteOpen(true);
  }, [invites]);

  const onShowCreate = () => {
    dispatch(createGameActions.showCreate());
  };

  const onHideCreate = () => {
    dispatch(createGameActions.hideCreate());
  };

  // prevent back navigation
  useEffect(() => {
    const unblock = history.block((tx) => {
      // Prevent back navigation from /game
      if (history.location.pathname === '/game' && appStatus === AppStatus.GAME && WsConnection.connected) {
        return false; // returning false cancels navigation
      }
      //tx.retry(); // proceed
    });

    return unblock; // cleanup
  }, [appStatus]);

  return (
    <div className={classes.mainCont}>
      <AppHeader />
      <Lobby />
      <GameList onShowCreate={onShowCreate} showCreate={showCreate} />
      {showCreate && <CreateGame onClose={() => onHideCreate()} />}
      <Chat roomId={0} showChat={true} isPrivate={false} />
      <Guide />
      {appStatus === AppStatus.GAME && <GameView />}
      {inviteOpen && <InviteDialog invite={invites[0]} onClose={() => setInviteOpen(false)} />}
    </div>
  );
};

interface GameContProps {
  GameView: FC;
  CreateGame: FC<ClosableCompProps>;
  Guide: FC;
}

export default GameCont;
